import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

import { useDocumentChatContext } from '@/modules/chat/contexts/DocumentChatProvider';
import { ChatShell } from '@/modules/common/Chat/components/ChatShell';

import { DocumentChatComposer } from './DocumentChatComposer';
import { DocumentChatEmptyState } from './DocumentChatEmptyState';
import { DocumentChatTranscript } from './DocumentChatTranscript';

export interface DocumentChatShellProps {
  header?: ReactNode;
  sx?: SxProps<Theme>;
  enableCopyCitationPopover?: boolean;
}

export function DocumentChatShell({
  header,
  sx,
  enableCopyCitationPopover = false,
}: DocumentChatShellProps) {
  const { messages } = useDocumentChatContext();

  return (
    <ChatShell
      header={header}
      emptyState={<DocumentChatEmptyState />}
      footer={<DocumentChatComposer />}
      hasMessages={messages.length > 0}
      sx={sx}
      transcript={
        <DocumentChatTranscript
          enableCopyCitationPopover={enableCopyCitationPopover}
        />
      }
    />
  );
}
